'use strict'

const API_BASE = 'https://tossp.yoooooo.com/index.php/index/private_universe_owned_item/'

function normalizePrivateUniverseOwnedItemLink (value) {
  const link = String(value || '').trim()
  return link === '无' ? '' : link
}

function createPrivateUniverseOwnedItemApi (http, FormDataType) {
  const FormDataConstructor = FormDataType || FormData

  function unwrap (response) {
    const payload = response && response.data
    if (!payload || Number(payload.code) !== 200) {
      throw new Error(payload && payload.msg ? payload.msg : '请求失败')
    }
    return payload.data
  }

  function handleError (error) {
    const payload = error && error.response && error.response.data
    if (payload && payload.msg) {
      throw new Error(payload.msg)
    }
    throw error instanceof Error ? error : new Error('请求失败')
  }

  return {
    list () {
      return http.get(API_BASE + 'category_list')
        .then(unwrap)
        .catch(handleError)
    },

    update (input) {
      const formData = new FormDataConstructor()
      formData.append('stat_id', input.stat_id)
      formData.append('namech', input.namech)
      formData.append('img', input.img)
      formData.append('qiutibili', input.qiutibili)
      formData.append('apmg', input.apmg)
      formData.append(
        'real_speed',
        input.real_speed === undefined || input.real_speed === null ? '1' : input.real_speed
      )
      formData.append(
        'sub_category',
        input.sub_category === undefined || input.sub_category === null
          ? '成年'
          : input.sub_category
      )
      formData.append(
        'right_offset',
        input.right_offset === undefined || input.right_offset === null
          ? '0'
          : input.right_offset
      )
      if (input.flight_position !== undefined && input.flight_position !== null) {
        formData.append('flight_position', input.flight_position)
      }
      if (input.gender !== undefined && input.gender !== null) {
        formData.append('gender', input.gender)
      }
      return http.post(API_BASE + 'update_item', formData)
        .then(unwrap)
        .catch(handleError)
    },

    remove (statId) {
      const formData = new FormDataConstructor()
      formData.append('stat_id', statId)
      return http.post(API_BASE + 'delete_item', formData)
        .then(unwrap)
        .catch(handleError)
    }
  }
}

export { createPrivateUniverseOwnedItemApi, normalizePrivateUniverseOwnedItemLink }



// WEBPACK FOOTER //
// ./src/api/privateUniverseOwnedItem.js